import { ReactNode } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';

import SellIcon from '#/assets/SellIcon';

import { cFF005C } from '#/colors';

import BaseContainer from './BaseContainer';
import BaseTextContent from './BaseTextContent';

interface Props {
  readonly children: ReactNode;
}

export default function Sell(props: Props) {
  const { children } = props;

  return (
    <Container>
      <SellIcon />
      <BaseTextContent>{children}</BaseTextContent>
    </Container>
  );
}

const Container = styled(BaseContainer)`
  background: ${rgba(cFF005C, 0.2)};
  border: 1px solid ${rgba(cFF005C, 0.3)};
  svg {
    color: ${cFF005C};
  }
`;
